// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-adapter-button {
    background-color: rgba(0,0,0,0);
    border: none;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-family: "DM Sans","Roboto","Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 16px;
    font-weight: 600;
    height: 48px;
    line-height: 48px;
    padding: 0 24px;
    border-radius: 4px
}

.wallet-adapter-button-trigger {
    background-color: #512da8
}

.wallet-adapter-button:not([disabled]):focus-visible {
    outline-color: #fff
}

.wallet-adapter-button:not([disabled]):hover {
    background-color: #1a1f2e
}

.wallet-adapter-button[disabled] {
    background: #404144;
    color: #999;
    cursor: not-allowed
}

.wallet-adapter-button-end-icon,.wallet-adapter-button-start-icon,.wallet-adapter-button-end-icon img,.wallet-adapter-button-start-icon img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px
}

.wallet-adapter-button-end-icon {
    margin-left: 12px
}

.wallet-adapter-button-start-icon {
    margin-right: 12px
}

.wallet-adapter-collapse {
    width: 100%
}

.wallet-adapter-dropdown {
    position: relative;
    display: inline-block
}

.wallet-adapter-dropdown-list {
    position: absolute;
    z-index: 99;
    display: grid;
    grid-template-rows: 1fr;
    grid-row-gap: 10px;
    padding: 10px;
    top: 100%;
    right: 0;
    margin: 0;
    list-style: none;
    background: #2c2d30;
    border-radius: 10px;
    box-shadow: 0px 8px 20px rgba(0,0,0,.6);
    opacity: 0;
    visibility: hidden;
    transition: opacity 200ms ease,transform 200ms ease,visibility 200ms;
    font-family: "DM Sans","Roboto","Helvetica Neue",Helvetica,Arial,sans-serif
}

.wallet-adapter-dropdown-list-active {
    opacity: 1;
    visibility: visible;
    transform: translateY(10px)
}

.wallet-adapter-dropdown-list-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border: none;
    outline: none;
    cursor: pointer;
    white-space: nowrap;
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    height: 37px;
    color: #fff
}

.wallet-adapter-dropdown-list-item:not([disabled]):hover {
    background-color: #1a1f2e
}

.wallet-adapter-modal-collapse-button svg {
    align-self: center;
    fill: #999
}

.wallet-adapter-modal-collapse-button.wallet-adapter-modal-collapse-button-active svg {
    transform: rotate(180deg);
    transition: transform ease-in 150ms
}

.wallet-adapter-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity linear 150ms;
    background: rgba(0,0,0,.5);
    z-index: 1040;
    overflow-y: auto
}

.wallet-adapter-modal.wallet-adapter-modal-fade-in {
    opacity: 1
}

.wallet-adapter-modal-button-close {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 18px;
    right: 18px;
    padding: 12px;
    cursor: pointer;
    background: #1a1f2e;
    border: none;
    border-radius: 50%
}

.wallet-adapter-modal-button-close:focus-visible {
    outline-color: #fff
}

.wallet-adapter-modal-button-close svg {
    fill: #777;
    transition: fill 200ms ease 0s
}

.wallet-adapter-modal-button-close:hover svg {
    fill: #fff
}

.wallet-adapter-modal-overlay {
    background: rgba(0,0,0,.5);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0
}

.wallet-adapter-modal-container {
    display: flex;
    margin: 3rem;
    min-height: calc(100vh - 6rem);
    align-items: center;
    justify-content: center
}

@media(max-width: 480px) {
    .wallet-adapter-modal-container {
        margin:1rem;
        min-height: calc(100vh - 2rem)
    }
}

.wallet-adapter-modal-wrapper {
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    z-index: 1050;
    max-width: 400px;
    border-radius: 10px;
    background: #10141f;
    box-shadow: 0px 8px 20px rgba(0,0,0,.6);
    font-family: "DM Sans","Roboto","Helvetica Neue",Helvetica,Arial,sans-serif;
    flex: 1 1
}

.wallet-adapter-modal-wrapper .wallet-adapter-button {
    width: 100%
}

.wallet-adapter-modal-title {
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    margin: 0;
    padding: 64px 48px 48px 48px;
    text-align: center;
    color: #fff
}

@media(max-width: 374px) {
    .wallet-adapter-modal-title {
        font-size:18px
    }
}

.wallet-adapter-modal-list {
    margin: 0 0 12px 0;
    padding: 0;
    width: 100%;
    list-style: none
}

.wallet-adapter-modal-list .wallet-adapter-button {
    font-weight: 400;
    border-radius: 0;
    font-size: 18px
}

.wallet-adapter-modal-list .wallet-adapter-button-end-icon,.wallet-adapter-modal-list .wallet-adapter-button-start-icon,.wallet-adapter-modal-list .wallet-adapter-button-end-icon img,.wallet-adapter-modal-list .wallet-adapter-button-start-icon img {
    width: 28px;
    height: 28px
}

.wallet-adapter-modal-list .wallet-adapter-button span {
    margin-left: auto;
    font-size: 14px;
    opacity: .6
}

.wallet-adapter-modal-list-more {
    cursor: pointer;
    border: none;
    padding: 12px 24px 24px 12px;
    align-self: flex-end;
    display: flex;
    align-items: center;
    background-color: rgba(0,0,0,0);
    color: #fff
}

.wallet-adapter-modal-list-more svg {
    transition: all .1s ease;
    fill: #fff;
    margin-left: .5rem
}

.wallet-adapter-modal-list-more-icon-rotate {
    transform: rotate(180deg)
}

.wallet-adapter-modal-middle {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 24px 24px 24px;
    box-sizing: border-box
}

.wallet-adapter-modal-middle-button {
    display: block;
    cursor: pointer;
    margin-top: 48px;
    width: 100%;
    background-color: #512da8;
    padding: 12px;
    font-size: 18px;
    border: none;
    border-radius: 8px;
    color: #fff
}

.vault-main-container {
    min-height: 100vh;
    width: 100vw;
    color: #fff;
    padding-bottom: 100px
}

.vault-placeholder-main-container {
    color: #fff;
    font-family: sans-serif;
    font-weight: 800;
    font-size: 40px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    flex-direction: column;
    letter-spacing: 3px
}

.vault-placeholder-main-container .vault-title {
    font-size: 30px;
    font-weight: 500;
    background: #ff2222;
    color: #000;
    padding: 10px 20px;
    border-radius: 10px;
    opacity: 1;
    animation: fadeinout 4s linear forwards infinite;
    margin-bottom: 50px
}

@keyframes fadeinout {
    0%,100% {
        opacity: .7
    }

    50% {
        opacity: 1
    }
}

.vault-wallet-wrapper {
    width: 100vw;
    padding-top: 70px
}

.vault-wallet-wrapper .wallet-btn {
    background: rgba(0,0,0,0) !important;
    border: 1px solid #ff2222 !important;
    font-family: "Poppins" !important;
    font-weight: 200 !important;
    font-size: 12px !important;
    padding: 12px 40px !important;
    margin: auto !important;
    display: flex;
    justify-content: center
}

.vault-wallet-wrapper .connect-alert {
    text-align: center;
    color: #fff;
    padding-bottom: 30px
}

.issue {
    text-align: center;
    color: #fff;
    font-size: 15px;
    width: 490px;
    margin: auto;
    margin-top: 20px;
    background: rgba(193,0,0,.4705882353);
    border-radius: 20px;
    padding: 20px;
    font-weight: 500
}

.vault-info-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: center
}

.vault-info-section .preview-image {
    object-fit: scale-down;
    margin-top: 40px
}

.vault-stats-section-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    align-content: center;
    margin-top: 60px;
    animation: fadeIn 1s ease-in
}

.vault-stats-section-container .vault-stats-item-container {
    background: #14191d;
    margin-inline:5px;display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    padding: 0px 10px;
    border-radius: 11px;
    min-width: 200px;
    min-height: 150px;
    margin-top: 10px;
    animation: fadeIn 1s ease-in
}

.vault-stats-section-container .vault-stats-item-container .value {
    position: relative;
    font-size: 1em;
    font-size: 26px;
    margin-bottom: 16px;
    animation: fadeIn 1s ease-in
}

.vault-stats-section-container .vault-stats-item-container .title {
    position: relative;
    font-size: 15px;
    font-weight: 200;
    animation: fadeIn 1s ease-in
}

.vault-stats-section-container .vault-stats-item-container .box {
    perspective: 120px;
    margin-right: 15px;
    animation: fadeIn 1s ease-in
}

.vault-stats-section-container .vault-stats-item-container .box .coin {
    width: .5em;
    height: .5em;
    border: 2px solid #fff;
    animation: spin 1.5s ease-in-out infinite
}

@keyframes spin {
    to {
        transform: rotateY(540deg)
    }
}

.vault-item-container {
    background: #14191d;
    margin-inline:5px;display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 11px;
    min-width: 200px;
    margin-top: 10px;
    min-height: 200px;
    animation: fadeIn 1s ease-in
}

.vault-item-container .image-container {
    position: relative;
    display: flex
}

.vault-item-container .image-container .image {
    width: 190px;
    height: 190px;
    border-radius: 8px;
    object-fit: contain
}

.vault-item-container .image-container .image-text {
    position: absolute;
    bottom: 0px;
    right: 0px;
    background: #ff2222;
    color: #000;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 300;
    border-radius: 0px 0px 8px 0px
}

.vault-item-container .busy-container {
    background: rgba(0,0,0,.7490196078);
    width: 190px;
    height: 190px;
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 8px;
    display: flex
}

.vault-item-container .busy-container .busy-loader {
    position: relative;
    width: 30px;
    height: 30px;
    border: 3px solid #ff2222;
    overflow: hidden;
    animation: spin 5s ease infinite;
    margin: auto
}

.vault-item-container .busy-container .busy-loader::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 30px;
    height: 30px;
    background-color: rgba(246,213,0,.5333333333);
    transform-origin: center bottom;
    transform: scaleY(1);
    animation: fill 5s linear infinite
}

.vault-item-container .staked-container {
    width: 100%;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between
}

.vault-item-container .staked-container .staked-info-container {
    width: 100%;
    display: flex;
    font-size: 12px;
    justify-content: center;
    border-radius: 0px;
    height: 100%;
    flex-direction: column
}

.vault-item-container .staked-container .staked-info-container .staked-info-section {
    padding-block:10px}

.vault-item-container .staked-container .staked-info-container .multiplier-info-section {
    margin-bottom: 10px;
    color: #fedd03;
    background: rgba(255,255,255,.1294117647);
    padding-block:2px;font-size: 10px
}

.vault-item-container .staked-container .staked-info-container .divider {
    width: 80%;
    border-top: 1px solid rgba(255,255,255,.102);
    margin: auto
}

.vault-item-container .staked-container .time-left {
    display: none;
    font-size: 15px;
    font-weight: 100
}

.vault-item-container .staked-container .time-left .items-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center
}

.vault-item-container .staked-container .time-left .items-container .divider {
    height: 24px;
    width: 1px;
    background: rgba(255,255,255,.1019607843);
    margin-inline:2px}

.vault-item-container .staked-container .time-left .items-container .item-container {
    position: relative;
    margin-inline:7px;display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center
}

.vault-item-container .staked-container .time-left .items-container .item-container .item-value {
    position: relative;
    font-weight: 200;
    margin-right: 3px
}

.vault-item-container .staked-container .time-left .items-container .item-container .item-title {
    position: relative;
    font-size: 11px;
    color: #ff2222;
    font-weight: 200
}

.vault-item-container .staked-container progress {
    border-radius: 70px;
    width: 100%;
    height: 10px;
    box-shadow: 1px 1px 4px rgba(0,0,0,.2)
}

.vault-item-container .staked-container progress::-webkit-progress-bar {
    background-color: #30383d;
    border-radius: 70px
}

.vault-item-container .staked-container progress::-webkit-progress-value {
    background-color: #06ffc3;
    border-radius: 70px;
    box-shadow: 0px 0px 5px 3px rgba(6,255,197,.4235294118)
}

@keyframes spin {
    50%,100% {
        transform: rotate(360deg)
    }
}

@keyframes fill {
    25%,50% {
        transform: scaleY(0)
    }

    100% {
        transform: scaleY(1)
    }
}

.vault-items-section-container {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
    flex-wrap: wrap;
    align-content: center;
    max-width: 1000px;
    margin: auto;
    margin-top: 20px;
    animation: fadeIn 1s ease-in
}

.section-title {
    margin: auto;
    text-align: center;
    margin-top: 80px;
    font-size: 30px;
    font-weight: 800;
    background: ff2222;
    color: #1c111b;
    letter-spacing: 10px;
    width: -moz-fit-content;
    width: fit-content;
    padding: 10px 80px;
    animation: fadeIn 1s ease-in
}

.section-title-unstaked {
    margin: auto;
    text-align: center;
    margin-top: 80px;
    font-size: 30px;
    font-weight: 200;
    color: ff2222;
    letter-spacing: 10px;
    width: -moz-fit-content;
    width: fit-content;
    padding: 10px 80px;
    animation: fadeIn 1s ease-in
}

.vault-toolbar-container {
    margin-inline:5px;display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    padding: 7px 0px;
    border-radius: 11px;
    min-width: 180px;
    margin-top: 20px;
    animation: fadeIn 1s ease-in;
    align-items: stretch;
    flex-wrap: wrap
}

.vault-toolbar-container .action-container {
    margin-inline:5px}

.vault-toolbar-container .action-container * .action-container-stake::before {
    font-size: 24px;
    padding: 8px 20px;
    letter-spacing: 5px;
    font-weight: 350;
    content: "STAKE"
}

.vault-toolbar-container .action-container * .action-container-unstake::before {
    font-size: 24px;
    padding: 8px 20px;
    letter-spacing: 5px;
    font-weight: 350;
    content: "UNSTAKE";
}

.vault-toolbar-container .vertical-border {
    position: relative;
    height: 40px;
    width: 2px;
    margin-inline:26px;background: rgba(255,255,255,.4117647059);
    border-radius: 10px
}

.vault-toolbar-container .auto-staking-container {
    background: #2d2444;
    margin-inline:5px;display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    padding: 10px 10px;
    border-radius: 11px;
    min-width: 200px;
    flex-wrap: nowrap;
    margin: 10px
}

.vault-toolbar-container .auto-staking-container .status-container {
    margin-right: 23px
}

.vault-toolbar-container .auto-staking-container .status-container .title {
    font-size: 9px
}

.vault-toolbar-container .auto-staking-container .status-container .status-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
    animation: fadeIn 1s ease-in
}

.vault-toolbar-container .auto-staking-container .status-container .status-container .status-indicator-off {
    width: 10px;
    height: 10px;
    border-radius: 20px;
    background: red;
    margin-right: 15px
}

.vault-toolbar-container .auto-staking-container .status-container .status-container .status-indicator-on {
    width: 10px;
    height: 10px;
    border-radius: 20px;
    background: #00a308;
    margin-right: 15px
}

.vault-toolbar-container .auto-staking-container .status-container .status-container .status {
    font-size: 21px;
    font-weight: 100
}

.vault-toolbar-container .balls {
    width: 4em;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    margin: auto;
    animation: fadeIn 1s ease-in
}

.vault-toolbar-container .balls div {
    width: .8em;
    height: .8em;
    border-radius: 50%;
    background-color: #fff
}

.vault-toolbar-container .balls div:nth-of-type(1) {
    transform: translateX(-100%);
    animation: left-swing .5s ease-in alternate infinite
}

.vault-toolbar-container .balls div:nth-of-type(3) {
    transform: translateX(-95%);
    animation: right-swing .5s ease-out alternate infinite
}

@keyframes left-swing {
    50%,100% {
        transform: translateX(95%)
    }
}

@keyframes right-swing {
    50% {
        transform: translateX(-95%)
    }

    100% {
        transform: translateX(100%)
    }
}

.vault-toolbar-container .box {
    perspective: 120px;
    margin-right: 15px;
    animation: fadeIn 1s ease-in
}

.vault-toolbar-container .box .coin {
    width: .5em;
    height: .5em;
    border: 2px solid #fff;
    animation: spin 1.5s ease-in-out infinite
}

@keyframes spin {
    to {
        transform: rotateY(540deg)
    }
}

.toolbat-alert-container {
    width: 340px;
    margin: auto;
    padding: 10px;
    border-radius: 10px;
    margin-top: 20px;
    text-align: center
}

.small {
    background: rgba(0,0,0,0);
    border: 1px solid #fff;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 5px !important;
    min-width: 87px !important;
    color: #fff;
    font-size: 11px !important;
    font-weight: 300
}

.ab-base {
    outline: none;
    border: none;
    font-family: "Poppins";
    cursor: pointer;
    transition: all .1s ease-in-out
}

.primary {
    background: #00ff6a;
    border-radius: 5px;
    font-size: 15px;
    padding: 12px;
    min-width: 230px;
    color: #000;
    font-weight: 500
}

.primary:hover {
    background: rgba(240,208,0,.9647058824)
}

.primary:active {
    background: rgba(211,183,1,.9647058824)
}

.light {
    background: rgba(0,0,0,0);
    border: 1px solid #fff;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 12px;
    min-width: 230px;
    color: #fff;
    font-size: 15px;
    font-weight: 300
}

.light:hover {
    background: rgba(240,208,0,.0823529412)
}

.light:active {
    background: rgba(255,255,255,.2117647059)
}

.close-overlay-btn {
    background: rgba(255,255,255,.0901960784);
    border-radius: 100px;
    position: fixed;
    z-index: 100;
    top: 20px;
    right: 220px;
    transition: all .2s
}

.close-overlay-btn:hover {
    background: rgba(255,255,255,.1568627451)
}

.close-overlay-btn:active {
    background: rgba(255,255,255,.2666666667)
}

.vault-stake-container {
    position: relative;
    display: flex;
    position: relative;
    width: 100vw;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    color: #fff;
    animation: fadeIn .4s ease-in
}

.vault-stake-container .title {
    position: relative;
    font-size: 2em
}

.vault-stake-container .explainer {
    position: relative
}

.vault-stake-container .no-items {
    margin-top: 60px;
    background: rgba(175,12,0,.2);
    padding: 10px
}

.vault-stake-container .form-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
    width: 80vw;
    margin: 0px auto;
    margin-top: 30px
}

.vault-stake-container .form-container .form-item-container {
    display: grid;
    justify-items: center;
    margin-top: 20px
}

.vault-stake-container .form-container .form-item-container .form-title {
    font-size: 13px
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;display: flex;
    cursor: pointer;
    transition: all 100ms;
    align-items: flex-start
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item {
    position: relative;
    width: 70px;
    height: 70px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms;
    opacity: .8
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {
    width: 100%;
    height: 100%;
    background: rgba(240,208,0,.7294117647);
    display: flex
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {
    width: 40px;
    margin: auto;
    object-fit: contain;
    height: 40px
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item-selected {
    opacity: .8
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item {
    opacity: 1
}

@keyframes fadeIn {
    0% {
        opacity: 0
    }

    100% {
        opacity: 1
    }
}

.select-plan-main-container {
    display: flex;
    max-width: 100vw;
    overflow: auto;
    margin-top: 40px;
    scrollbar-width: none;
    flex-wrap: wrap;
    justify-content: space-around
}

.select-plan-main-container::-webkit-scrollbar {
    display: none
}

.select-plan-main-container .plan-container {
    background: rgba(64,64,64,.1294117647);
    padding: 25px;
    border: 1px solid #ffeb3b;
    border-radius: 8px;
    margin-bottom: 20px;
    max-width: 380px;
    min-width: 290px;
    overflow: hidden;
    margin-inline:20px}

.select-plan-main-container .line-break {
    white-space: pre-line;
    width: revert;
    word-wrap: break-word
}

.minting-button-main-container {
    padding: 50px 20px;
    border: 1px solid rgba(255,255,255,.2392156863);
    border-radius: 10px;
    min-width: 200px;
    margin-top: 40px;
    background: rgba(30,30,30,.5411764706);
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    animation: fadeIn .2s ease-in
}

.minting-button-main-container .message {
    font-weight: 200;
    font-size: 24px
}

.minting-button-main-container .may-take {
    font-size: 12px;
    margin-top: 10px;
    font-weight: 600;
    color: rgba(255,255,255,.4784313725)
}

.wallet-btn {
    background: rgba(0,0,0,0) !important;
    border: 1px solid #ff2222 !important;
    font-family: "Poppins" !important;
    font-weight: 200 !important;
    font-size: 12px !important;
    padding: 0px 40px !important;
    margin: auto
}

.minting-button-loader {
    position: relative;
    width: 30px;
    height: 30px;
    border: 3px solid #ff2222;
    overflow: hidden;
    animation: spin 5s ease infinite;
    margin: auto;
    margin-bottom: 20px
}

.minting-button-loader::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 30px;
    height: 30px;
    background-color: rgba(246,213,0,.5333333333);
    transform-origin: center bottom;
    transform: scaleY(1);
    animation: fill 5s linear infinite
}

@keyframes spin {
    50%,100% {
        transform: rotate(360deg)
    }
}

@keyframes fill {
    25%,50% {
        transform: scaleY(0)
    }

    100% {
        transform: scaleY(1)
    }
}

.select-plan-main-container .plan-container {
    background: rgba(64,64,64,.1294117647);
    padding: 25px;
    border: 1px solid #ffeb3b;
    border-radius: 8px;
    margin-bottom: 20px;
    max-width: 380px;
    min-width: 290px;
    overflow: hidden
}

.select-plan-main-container .line-break {
    white-space: pre-line;
    width: revert;
    word-wrap: break-word
}

*>.reward-token-name {
    display: inherit
}

.close-overlay-btn {
    background: rgba(255,255,255,.0901960784);
    border-radius: 100px;
    position: fixed;
    z-index: 100;
    top: 20px;
    right: 220px;
    transition: all .2s
}

.close-overlay-btn:hover {
    background: rgba(255,255,255,.1568627451)
}

.close-overlay-btn:active {
    background: rgba(255,255,255,.2666666667)
}

.vault-stake-container {
    position: relative;
    display: flex;
    position: relative;
    width: 100vw;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    color: #fff;
    animation: fadeIn .4s ease-in
}

.vault-stake-container .title {
    position: relative;
    font-size: 2em
}

.vault-stake-container .explainer {
    position: relative
}

.vault-stake-container .no-items {
    margin-top: 60px;
    background: rgba(175,12,0,.2);
    padding: 10px
}

.vault-stake-container .form-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
    width: 80vw;
    margin: 0px auto;
    margin-top: 30px
}

.vault-stake-container .form-container .form-item-container {
    display: grid;
    justify-items: center;
    margin-top: 20px
}

.vault-stake-container .form-container .form-item-container .form-title {
    font-size: 13px
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;display: flex;
    cursor: pointer;
    transition: all 100ms;
    align-items: flex-start
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item {
    position: relative;
    width: 70px;
    height: 70px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms;
    opacity: .8
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {
    width: 100%;
    height: 100%;
    background: rgba(240,208,0,.7294117647);
    display: flex
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {
    width: 40px;
    margin: auto;
    object-fit: contain;
    height: 40px
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item-selected {
    opacity: .8
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item {
    opacity: 1
}

@keyframes fadeIn {
    0% {
        opacity: 0
    }

    100% {
        opacity: 1
    }
}

.select-plan-main-container .plan-container {
    background: rgba(64,64,64,.1294117647);
    padding: 25px;
    border: 1px solid #ffeb3b;
    border-radius: 8px;
    margin-bottom: 20px;
    max-width: 380px;
    min-width: 290px;
    overflow: hidden
}

.select-plan-main-container .line-break {
    white-space: pre-line;
    width: revert;
    word-wrap: break-word
}

.minting-button-main-container {
    padding: 50px 20px;
    border: 1px solid rgba(255,255,255,.2392156863);
    border-radius: 10px;
    min-width: 200px;
    margin-top: 40px;
    background: rgba(30,30,30,.5411764706);
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    animation: fadeIn .2s ease-in
}

.minting-button-main-container .message {
    font-weight: 200;
    font-size: 24px
}

.minting-button-main-container .may-take {
    font-size: 12px;
    margin-top: 10px;
    font-weight: 600;
    color: rgba(255,255,255,.4784313725)
}

.wallet-btn {
    background: rgba(0,0,0,0) !important;
    border: 1px solid #ff2222 !important;
    font-family: "Poppins" !important;
    font-weight: 200 !important;
    font-size: 12px !important;
    padding: 0px 40px !important;
    margin: auto
}

.minting-button-loader {
    position: relative;
    width: 30px;
    height: 30px;
    border: 3px solid #ff2222;
    overflow: hidden;
    animation: spin 5s ease infinite;
    margin: auto;
    margin-bottom: 20px
}

.minting-button-loader::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 30px;
    height: 30px;
    background-color: rgba(246,213,0,.5333333333);
    transform-origin: center bottom;
    transform: scaleY(1);
    animation: fill 5s linear infinite
}

@keyframes spin {
    50%,100% {
        transform: rotate(360deg)
    }
}

@keyframes fill {
    25%,50% {
        transform: scaleY(0)
    }

    100% {
        transform: scaleY(1)
    }
}

.vault-balance-main-container {
    position: relative;
    display: flex;
    margin: auto;
    align-items: center;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 20px;
}

.vault-balance-main-container .vault-balance-container {
    background: #1d1827;
    margin-inline:5px;display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    padding: 20px 20px;
    border-radius: 11px;
    min-width: 220px;
    margin-top: 10px;
    animation: fadeIn 1s ease-in
}

.vault-balance-main-container .vault-balance-container .vault-balance-split-container .token-withdraw-container {
    display: flex;
    justify-content: space-between;
}

.vault-balance-main-container .vault-balance-container .vault-balance-split-container .token-withdraw-container .token-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start
}

.vault-balance-main-container .vault-balance-container .vault-balance-split-container .token-withdraw-container .token-container .token-title {
    font-weight: 300;
    font-size: 11px
}

.vault-balance-main-container .vault-balance-container .vault-balance-split-container .token-withdraw-container .token-container .token-value {
    font-weight: 600;
    color: #00ff6a;
    font-size: 21px
}

.vault-balance-main-container .vault-balance-container .vault-balance-split-container .reward-pool-alert-container {
    background: rgba(255,0,0,.368627451);
    padding: 20px;
    width: 300px;
    font-size: 11px;
    margin-top: 10px;
    border-radius: 10px
}

.vault-balance-main-container .vault-balance-container .vault-balance-split-container .reward-pool-alert-container .title {
    font-weight: 700
}

.vault-balance-main-container .vault-balance-container .vault-balance-split-container .reward-pool-alert-container .description {
    margin: 0px
}

.close-overlay-btn {
    background: rgba(255,255,255,.0901960784);
    border-radius: 100px;
    position: fixed;
    z-index: 100;
    top: 20px;
    right: 220px;
    transition: all .2s
}

.close-overlay-btn:hover {
    background: rgba(255,255,255,.1568627451)
}

.close-overlay-btn:active {
    background: rgba(255,255,255,.2666666667)
}

.multiplier-stake-container {
    position: relative;
    display: flex;
    position: relative;
    width: 100vw;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    color: #fff;
    animation: fadeIn .4s ease-in
}

.multiplier-stake-container .title {
    position: relative;
    font-size: 2em
}

.multiplier-stake-container .explainer {
    position: relative;
    max-width: 95vw;
    text-align: center
}

.multiplier-stake-container .no-items {
    margin-top: 60px;
    background: rgba(175,12,0,.2);
    padding: 10px
}

.multiplier-stake-container .form-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
    width: 80vw;
    margin: 0px auto;
    margin-top: 30px
}

.multiplier-stake-container .form-container .form-item-container {
    display: grid;
    justify-items: center;
    margin-top: 20px
}

.multiplier-stake-container .form-container .form-item-container .form-title {
    font-size: 13px
}

.multiplier-stake-container .form-container .form-item-container .form-item-inner-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;display: flex;
    cursor: pointer;
    transition: all 100ms;
    align-items: flex-start
}

.multiplier-stake-container .form-container .form-item-container .form-item-inner-container .form-item {
    position: relative;
    width: 70px;
    height: 70px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms;
    opacity: .8
}

.multiplier-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms
}

.multiplier-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {
    width: 100%;
    height: 100%;
    background: rgba(240,208,0,.7294117647);
    display: flex
}

.multiplier-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {
    width: 40px;
    margin: auto;
    object-fit: contain;
    height: 40px
}

.multiplier-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item-selected {
    opacity: .8
}

.multiplier-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item {
    opacity: 1
}

@keyframes fadeIn {
    0% {
        opacity: 0
    }

    100% {
        opacity: 1
    }
}

.select-plan-main-container {
    display: flex;
    max-width: 100vw;
    overflow: auto;
    margin-top: 40px;
    -ms-overflow-style: none;
    scrollbar-width: none
}

.select-plan-main-container::-webkit-scrollbar {
    display: none
}

.select-plan-main-container .plan-container {
    background: rgba(64,64,64,.1294117647);
    padding: 25px;
    border: 1px solid #ffeb3b;
    border-radius: 8px;
    margin-bottom: 20px;
    max-width: 380px;
    min-width: 290px;
    overflow: hidden;
    margin-inline:20px}

.select-plan-main-container .line-break {
    white-space: pre-line;
    width: revert;
    word-wrap: break-word
}

.select-multiplier-plan-main-container {
    display: flex;
    overflow: auto;
    max-width: 100vw;
    flex-wrap: wrap;
    justify-content: center
}

.select-multiplier-plan-main-container .plan-container {
    background: rgba(64,64,64,.1294117647);
    padding: 25px;
    border: 1px solid #ffeb3b;
    border-radius: 8px;
    margin-bottom: 20px;
    max-width: 380px;
    margin-top: 40px;
    min-width: 290px;
    overflow: hidden;
    margin-inline:20px}

.select-multiplier-plan-main-container .line-break {
    white-space: pre-line;
    width: revert;
    word-wrap: break-word
}

.minting-button-main-container {
    padding: 50px 20px;
    border: 1px solid rgba(255,255,255,.2392156863);
    border-radius: 10px;
    min-width: 200px;
    margin-top: 40px;
    background: rgba(30,30,30,.5411764706);
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    animation: fadeIn .2s ease-in
}

.minting-button-main-container .message {
    font-weight: 200;
    font-size: 24px
}

.minting-button-main-container .may-take {
    font-size: 12px;
    margin-top: 10px;
    font-weight: 600;
    color: rgba(255,255,255,.4784313725)
}

.wallet-btn {
    background: rgba(0,0,0,0) !important;
    border: 1px solid #ff2222 !important;
    font-family: "Poppins" !important;
    font-weight: 200 !important;
    font-size: 12px !important;
    padding: 0px 40px !important;
    margin: auto
}

.minting-button-loader {
    position: relative;
    width: 30px;
    height: 30px;
    border: 3px solid #ff2222;
    overflow: hidden;
    animation: spin 5s ease infinite;
    margin: auto;
    margin-bottom: 20px
}

.minting-button-loader::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 30px;
    height: 30px;
    background-color: rgba(246,213,0,.5333333333);
    transform-origin: center bottom;
    transform: scaleY(1);
    animation: fill 5s linear infinite
}

@keyframes spin {
    50%,100% {
        transform: rotate(360deg)
    }
}

@keyframes fill {
    25%,50% {
        transform: scaleY(0)
    }

    100% {
        transform: scaleY(1)
    }
}

.multiplier-main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(0,0,0,.3294117647);
    padding-block:20px;margin-block:20px}

.multiplier-main-container .multiplier-title {
    margin: auto;
    text-align: center;
    margin-top: 0px;
    font-size: 17px;
    font-weight: 900;
    color: ff2222;
    letter-spacing: 4px;
    width: -moz-fit-content;
    width: fit-content;
    padding: 10px 80px;
    animation: fadeIn 1s ease-in
}

.multiplier-main-container .multiplier-actions-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    flex-direction: row;
    justify-content: center;
    align-items: stretch
}

.multiplier-main-container .multiplier-items-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center
}

.vault-multiplier-item-container {
    background: #312745;
    margin-inline:5px;display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 11px;
    margin-top: 10px;
    cursor: pointer;
    animation: fadeIn 1s ease-in;
    transition: all .3s;
    justify-content: space-between
}

.vault-multiplier-item-container:hover {
    background: #212a30
}

.vault-multiplier-item-container:active {
    background: #181d23
}

.vault-multiplier-item-container .image-container {
    position: relative;
    display: flex
}

.vault-multiplier-item-container .image-container .image {
    width: 90px;
    height: 90px;
    border-radius: 7px;
    object-fit: contain
}

.vault-multiplier-item-container .image-container .image-text {
    position: absolute;
    bottom: 0px;
    right: 0px;
    background: #ff2222;
    color: #000;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 300;
    border-radius: 0px 0px 8px 0px
}

.vault-multiplier-item-container .busy-container {
    background: rgba(0,0,0,.7490196078);
    width: 190px;
    height: 190px;
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 8px;
    display: flex
}

.vault-multiplier-item-container .busy-container .busy-loader {
    position: relative;
    width: 30px;
    height: 30px;
    border: 3px solid #ff2222;
    overflow: hidden;
    animation: spin 5s ease infinite;
    margin: auto
}

.vault-multiplier-item-container .busy-container .busy-loader::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 30px;
    height: 30px;
    background-color: rgba(246,213,0,.5333333333);
    transform-origin: center bottom;
    transform: scaleY(1);
    animation: fill 5s linear infinite
}

.vault-multiplier-item-container .staked-container {
    width: 100%;
    text-align: center
}

.vault-multiplier-item-container .staked-container .busy-unstaking {
    font-size: 10px;
    margin-top: 8px
}

.vault-multiplier-item-container .staked-container .staked-info-container {
    width: 100%;
    display: flex;
    font-size: 12px;
    justify-content: space-around;
    border-radius: 0px;
    flex-direction: column
}

.vault-multiplier-item-container .staked-container .staked-info-container .staked-info-section {
    padding-block:4px}

.vault-multiplier-item-container .staked-container .staked-info-container .staked-info-section .in-use {
    font-size: 7px
}

.vault-multiplier-item-container .staked-container .staked-info-container .staked-info-section .UNLIMITED {
    color: ff2222;
    font-size: 13px
}

.vault-multiplier-item-container .staked-container .staked-info-container .staked-program-info-section {
    padding-block:4px;font-size: 10px
}

.vault-multiplier-item-container .staked-container .staked-info-container .divider {
    width: 80%;
    border-top: 1px solid rgba(255,255,255,.102);
    margin: auto
}

.vault-multiplier-item-container .staked-container .activate {
    font-size: 10px;
    margin-top: 10px;
    color: #ff2222
}

.vault-multiplier-item-container .staked-container .time-left {
    font-size: 15px;
    font-weight: 100
}

.vault-multiplier-item-container .staked-container .time-left .items-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center
}

.vault-multiplier-item-container .staked-container .time-left .items-container .divider {
    height: 24px;
    width: 1px;
    background: rgba(255,255,255,.1019607843);
    margin-inline:2px}

.vault-multiplier-item-container .staked-container .time-left .items-container .item-container {
    position: relative;
    margin-inline:7px;display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center
}

.vault-multiplier-item-container .staked-container .time-left .items-container .item-container .item-value {
    position: relative;
    font-weight: 200;
    margin-right: 3px
}

.vault-multiplier-item-container .staked-container .time-left .items-container .item-container .item-title {
    position: relative;
    font-size: 11px;
    color: #ff2222;
    font-weight: 200
}

.vault-multiplier-item-container .staked-container progress {
    border-radius: 70px;
    width: 100%;
    height: 10px;
    box-shadow: 1px 1px 4px rgba(0,0,0,.2)
}

.vault-multiplier-item-container .staked-container progress::-webkit-progress-bar {
    background-color: #30383d;
    border-radius: 70px
}

.vault-multiplier-item-container .staked-container progress::-webkit-progress-value {
    background-color: #06ffc3;
    border-radius: 70px;
    box-shadow: 0px 0px 5px 3px rgba(6,255,197,.4235294118)
}

@keyframes spin {
    50%,100% {
        transform: rotate(360deg)
    }
}

@keyframes fill {
    25%,50% {
        transform: scaleY(0)
    }

    100% {
        transform: scaleY(1)
    }
}

.close-overlay-btn {
    background: rgba(255,255,255,.0901960784);
    border-radius: 100px;
    position: fixed;
    z-index: 100;
    top: 20px;
    right: 220px;
    transition: all .2s
}

.close-overlay-btn:hover {
    background: rgba(255,255,255,.1568627451)
}

.close-overlay-btn:active {
    background: rgba(255,255,255,.2666666667)
}

.multiplier-info-main-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center
}

.multiplier-info-main-container .multiplier-image {
    width: 100px;
    height: 100px;
    object-fit: contain;
    border-radius: 10px
}

.multiplier-info-main-container .multiplier-info-container .multiplier-name {
    color: #ff2222;
    font-weight: 500
}

.multiplier-info-main-container .multiplier-info-container .multiplier-bonus-desc {
    font-size: 14px;
    width: 200px;
    margin-top: 10px;
    font-weight: 200
}

.fade-in-ani {
    animation: fadeIn .2s ease-in
}

.multipler-activate-container {
    position: relative;
    display: flex;
    position: relative;
    width: 100vw;
    flex-direction: column;
    align-items: center;
    margin-block:100px;color: #fff;
    animation: fadeIn .4s ease-in
}

.multipler-activate-container .multiplier-helper {
    background: rgba(255,255,255,.0588235294);
    padding: 12px;
    width: 320px;
    margin-block:30px;text-align: center;
    font-weight: 100
}

.multipler-activate-container .title {
    position: relative;
    font-size: 2em
}

.multipler-activate-container .explainer {
    position: relative
}

.multipler-activate-container .acitions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-block:10px;justify-content: center
}

.multipler-activate-container .no-items {
    margin-top: 60px;
    background: rgba(175,12,0,.2);
    padding: 10px
}

.multipler-activate-container .multiplier-form-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
    width: 80vw;
    margin: 0px auto;
    margin-top: 30px
}

.multipler-activate-container .multiplier-form-container .form-item-container {
    display: grid;
    justify-items: center;
    margin-top: 20px
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-title {
    font-size: 13px
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-calculated-bonus {
    color: #ff2222;
    font-size: 13px
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;display: flex;
    cursor: pointer;
    transition: all 100ms;
    align-items: flex-start
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item {
    position: relative;
    width: 70px;
    height: 70px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms;
    opacity: .8
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item .selected-container {
    width: 100%;
    height: 100%;
    background: rgba(240,208,0,.7294117647);
    display: flex
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item .selected-container .tick {
    width: 30px;
    margin: auto;
    object-fit: contain;
    height: 30px
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item-selected {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {
    width: 100%;
    height: 100%;
    background: rgba(240,208,0,.7294117647);
    display: flex
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {
    width: 40px;
    margin: auto;
    object-fit: contain;
    height: 40px
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container:hover .form-item-selected {
    opacity: .8
}

.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container:hover .form-item {
    opacity: 1
}

@keyframes fadeIn {
    0% {
        opacity: 0
    }

    100% {
        opacity: 1
    }

    0% {
        opacity: 0
    }
}

.select-plan-main-container {
    display: flex;
    max-width: 100vw;
    overflow: auto;
    margin-top: 40px;
    -ms-overflow-style: none;
    scrollbar-width: none
}

.select-plan-main-container::-webkit-scrollbar {
    display: none
}

.select-plan-main-container .plan-container {
    background: rgba(64,64,64,.1294117647);
    padding: 25px;
    border: 1px solid #ffeb3b;
    border-radius: 8px;
    margin-bottom: 20px;
    max-width: 380px;
    min-width: 290px;
    overflow: hidden;
    margin-inline:20px}

.select-plan-main-container .line-break {
    white-space: pre-line;
    width: revert;
    word-wrap: break-word
}

.close-overlay-btn {
    background: rgba(255,255,255,.0901960784);
    border-radius: 100px;
    position: fixed;
    z-index: 100;
    top: 20px;
    right: 220px;
    transition: all .2s
}

.close-overlay-btn:hover {
    background: rgba(255,255,255,.1568627451)
}

.close-overlay-btn:active {
    background: rgba(255,255,255,.2666666667)
}

.vault-stake-container {
    position: relative;
    display: flex;
    position: relative;
    width: 100vw;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    color: #fff;
    animation: fadeIn .4s ease-in
}

.vault-stake-container .title {
    position: relative;
    font-size: 2em
}

.vault-stake-container .explainer {
    position: relative
}

.vault-stake-container .no-items {
    margin-top: 60px;
    background: rgba(175,12,0,.2);
    padding: 10px
}

.vault-stake-container .form-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
    width: 80vw;
    margin: 0px auto;
    margin-top: 30px
}

.vault-stake-container .form-container .form-item-container {
    display: grid;
    justify-items: center;
    margin-top: 20px
}

.vault-stake-container .form-container .form-item-container .form-title {
    font-size: 13px
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;display: flex;
    cursor: pointer;
    transition: all 100ms;
    align-items: flex-start
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item {
    position: relative;
    width: 70px;
    height: 70px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms;
    opacity: .8
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected {
    position: relative;
    width: 100px;
    height: 100px;
    margin-inline:10px;margin: 0px auto;
    cursor: pointer;
    transition: all 100ms
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {
    width: 100%;
    height: 100%;
    background: rgba(240,208,0,.7294117647);
    display: flex
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {
    width: 40px;
    margin: auto;
    object-fit: contain;
    height: 40px
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item-selected {
    opacity: .8
}

.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item {
    opacity: 1
}

@keyframes fadeIn {
    0% {
        opacity: 0
    }

    100% {
        opacity: 1
    }
}

.select-plan-main-container .plan-container {
    background: rgba(64,64,64,.1294117647);
    padding: 25px;
    border: 1px solid #ffeb3b;
    border-radius: 8px;
    margin-bottom: 20px;
    max-width: 380px;
    min-width: 290px;
    overflow: hidden
}

.select-plan-main-container .line-break {
    white-space: pre-line;
    width: revert;
    word-wrap: break-word
}
`, "",{"version":3,"sources":["webpack://./src/bundle.css"],"names":[],"mappings":"AAA6F;IACzF,+BAA+B;IAC/B,YAAY;IACZ,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,2EAA2E;IAC3E,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,uCAAuC;IACvC,UAAU;IACV,kBAAkB;IAClB,oEAAoE;IACpE;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,0BAA0B;IAC1B,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,uCAAuC;IACvC,2EAA2E;IAC3E;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B;AACJ;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IAEV,gDAAgD;IAChD;AACJ;;AAYA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;IAC7B,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB,CAAC,aAAa;IAC/B,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB,CAAC,aAAa;IAC/B,sBAAsB;IACtB,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,+BAA+B;IAC/B,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;;AAEtB;IACI,mBAAmB;IACnB,cAAc;IACd,yCAAyC;IACzC,iBAAiB,CAAC;AACtB;;AAEA;IACI,UAAU;IACV,4CAA4C;IAC5C;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yCAAyC;IACzC,iBAAiB;;AAErB;IACI,kBAAkB;IAClB,iBAAiB,CAAC,aAAa;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB,CAAC,aAAa;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;;AAErB;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB,CAAC,yCAAyC;IAC5D;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB,CAAC,aAAa;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,WAAW;IACX,0BAA0B;IAC1B;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,aAAa;IAChC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;AAEtB;IACI,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,+BAA+B;IAC/B,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,aAAa;IAChC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,+BAA+B;IAC/B,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB,CAAC,aAAa;IAC/B,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,aAAa;IAChC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;AAEtB;IACI,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;AAEtB;IACI,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,+BAA+B;IAC/B,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mCAAmC;IACnC,kBAAkB,CAAC,iBAAiB;;AAExC;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB,CAAC,aAAa;IAC/B,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,+BAA+B;IAC/B,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;;AAErB;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,iBAAiB,CAAC;AACtB;;AAEA;IACI,UAAU;IACV,4CAA4C;IAC5C;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yCAAyC;IACzC,iBAAiB;;AAErB;IACI,kBAAkB;IAClB,iBAAiB,CAAC,aAAa;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB,CAAC,WAAW;IAC9B;AACJ;;AAEA;IACI,yCAAyC;IACzC,aAAa;IACb,YAAY;IACZ,iBAAiB,CAAC,kBAAkB;IACpC;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,iBAAiB,CAAC;AACtB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,aAAa;IAChC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;AAEtB;IACI,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,aAAa;IAChC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,CAAC,gBAAgB;IACnC,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb;AACJ","sourcesContent":["@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap); .wallet-adapter-button {\n    background-color: rgba(0,0,0,0);\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    font-family: \"DM Sans\",\"Roboto\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    height: 48px;\n    line-height: 48px;\n    padding: 0 24px;\n    border-radius: 4px\n}\n\n.wallet-adapter-button-trigger {\n    background-color: #512da8\n}\n\n.wallet-adapter-button:not([disabled]):focus-visible {\n    outline-color: #fff\n}\n\n.wallet-adapter-button:not([disabled]):hover {\n    background-color: #1a1f2e\n}\n\n.wallet-adapter-button[disabled] {\n    background: #404144;\n    color: #999;\n    cursor: not-allowed\n}\n\n.wallet-adapter-button-end-icon,.wallet-adapter-button-start-icon,.wallet-adapter-button-end-icon img,.wallet-adapter-button-start-icon img {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px\n}\n\n.wallet-adapter-button-end-icon {\n    margin-left: 12px\n}\n\n.wallet-adapter-button-start-icon {\n    margin-right: 12px\n}\n\n.wallet-adapter-collapse {\n    width: 100%\n}\n\n.wallet-adapter-dropdown {\n    position: relative;\n    display: inline-block\n}\n\n.wallet-adapter-dropdown-list {\n    position: absolute;\n    z-index: 99;\n    display: grid;\n    grid-template-rows: 1fr;\n    grid-row-gap: 10px;\n    padding: 10px;\n    top: 100%;\n    right: 0;\n    margin: 0;\n    list-style: none;\n    background: #2c2d30;\n    border-radius: 10px;\n    box-shadow: 0px 8px 20px rgba(0,0,0,.6);\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 200ms ease,transform 200ms ease,visibility 200ms;\n    font-family: \"DM Sans\",\"Roboto\",\"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\n.wallet-adapter-dropdown-list-active {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(10px)\n}\n\n.wallet-adapter-dropdown-list-item {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    white-space: nowrap;\n    box-sizing: border-box;\n    padding: 0 20px;\n    width: 100%;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    height: 37px;\n    color: #fff\n}\n\n.wallet-adapter-dropdown-list-item:not([disabled]):hover {\n    background-color: #1a1f2e\n}\n\n.wallet-adapter-modal-collapse-button svg {\n    align-self: center;\n    fill: #999\n}\n\n.wallet-adapter-modal-collapse-button.wallet-adapter-modal-collapse-button-active svg {\n    transform: rotate(180deg);\n    transition: transform ease-in 150ms\n}\n\n.wallet-adapter-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    opacity: 0;\n    transition: opacity linear 150ms;\n    background: rgba(0,0,0,.5);\n    z-index: 1040;\n    overflow-y: auto\n}\n\n.wallet-adapter-modal.wallet-adapter-modal-fade-in {\n    opacity: 1\n}\n\n.wallet-adapter-modal-button-close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 18px;\n    right: 18px;\n    padding: 12px;\n    cursor: pointer;\n    background: #1a1f2e;\n    border: none;\n    border-radius: 50%\n}\n\n.wallet-adapter-modal-button-close:focus-visible {\n    outline-color: #fff\n}\n\n.wallet-adapter-modal-button-close svg {\n    fill: #777;\n    transition: fill 200ms ease 0s\n}\n\n.wallet-adapter-modal-button-close:hover svg {\n    fill: #fff\n}\n\n.wallet-adapter-modal-overlay {\n    background: rgba(0,0,0,.5);\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0\n}\n\n.wallet-adapter-modal-container {\n    display: flex;\n    margin: 3rem;\n    min-height: calc(100vh - 6rem);\n    align-items: center;\n    justify-content: center\n}\n\n@media(max-width: 480px) {\n    .wallet-adapter-modal-container {\n        margin:1rem;\n        min-height: calc(100vh - 2rem)\n    }\n}\n\n.wallet-adapter-modal-wrapper {\n    box-sizing: border-box;\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    z-index: 1050;\n    max-width: 400px;\n    border-radius: 10px;\n    background: #10141f;\n    box-shadow: 0px 8px 20px rgba(0,0,0,.6);\n    font-family: \"DM Sans\",\"Roboto\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    flex: 1\n}\n\n.wallet-adapter-modal-wrapper .wallet-adapter-button {\n    width: 100%\n}\n\n.wallet-adapter-modal-title {\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 36px;\n    margin: 0;\n    padding: 64px 48px 48px 48px;\n    text-align: center;\n    color: #fff\n}\n\n@media(max-width: 374px) {\n    .wallet-adapter-modal-title {\n        font-size:18px\n    }\n}\n\n.wallet-adapter-modal-list {\n    margin: 0 0 12px 0;\n    padding: 0;\n    width: 100%;\n    list-style: none\n}\n\n.wallet-adapter-modal-list .wallet-adapter-button {\n    font-weight: 400;\n    border-radius: 0;\n    font-size: 18px\n}\n\n.wallet-adapter-modal-list .wallet-adapter-button-end-icon,.wallet-adapter-modal-list .wallet-adapter-button-start-icon,.wallet-adapter-modal-list .wallet-adapter-button-end-icon img,.wallet-adapter-modal-list .wallet-adapter-button-start-icon img {\n    width: 28px;\n    height: 28px\n}\n\n.wallet-adapter-modal-list .wallet-adapter-button span {\n    margin-left: auto;\n    font-size: 14px;\n    opacity: .6\n}\n\n.wallet-adapter-modal-list-more {\n    cursor: pointer;\n    border: none;\n    padding: 12px 24px 24px 12px;\n    align-self: flex-end;\n    display: flex;\n    align-items: center;\n    background-color: rgba(0,0,0,0);\n    color: #fff\n}\n\n.wallet-adapter-modal-list-more svg {\n    transition: all .1s ease;\n    fill: #fff;\n    margin-left: .5rem\n}\n\n.wallet-adapter-modal-list-more-icon-rotate {\n    transform: rotate(180deg)\n}\n\n.wallet-adapter-modal-middle {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0 24px 24px 24px;\n    box-sizing: border-box\n}\n\n.wallet-adapter-modal-middle-button {\n    display: block;\n    cursor: pointer;\n    margin-top: 48px;\n    width: 100%;\n    background-color: #512da8;\n    padding: 12px;\n    font-size: 18px;\n    border: none;\n    border-radius: 8px;\n    color: #fff\n}\n\n.vault-main-container {\n    min-height: 100vh;\n    width: 100vw;\n    color: #fff;\n    padding-bottom: 100px\n}\n\n.vault-placeholder-main-container {\n    color: #fff;\n    font-family: sans-serif;\n    font-weight: 800;\n    font-size: 40px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    flex-direction: column;\n    letter-spacing: 3px\n}\n\n.vault-placeholder-main-container .vault-title {\n    font-size: 30px;\n    font-weight: 500;\n    background: #ff2222;\n    color: #000;\n    padding: 10px 20px;\n    border-radius: 10px;\n    opacity: 1;\n    -webkit-animation: fadeinout 4s linear forwards infinite;\n    animation: fadeinout 4s linear forwards infinite;\n    margin-bottom: 50px\n}\n\n@-webkit-keyframes fadeinout {\n    0%,100% {\n        opacity: .7\n    }\n\n    50% {\n        opacity: 1\n    }\n}\n\n@keyframes fadeinout {\n    0%,100% {\n        opacity: .7\n    }\n\n    50% {\n        opacity: 1\n    }\n}\n\n.vault-wallet-wrapper {\n    width: 100vw;\n    padding-top: 70px\n}\n\n.vault-wallet-wrapper .wallet-btn {\n    background: rgba(0,0,0,0) !important;\n    border: 1px solid #ff2222 !important;\n    font-family: \"Poppins\" !important;\n    font-weight: 200 !important;\n    font-size: 12px !important;\n    padding: 12px 40px !important;\n    margin: auto !important;\n    display: flex;\n    justify-content: center\n}\n\n.vault-wallet-wrapper .connect-alert {\n    text-align: center;\n    color: #fff;\n    padding-bottom: 30px\n}\n\n.issue {\n    text-align: center;\n    color: #fff;\n    font-size: 15px;\n    width: 490px;\n    margin: auto;\n    margin-top: 20px;\n    background: rgba(193,0,0,.4705882353);\n    border-radius: 20px;\n    padding: 20px;\n    font-weight: 500\n}\n\n.vault-info-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    align-content: center;\n    justify-content: center\n}\n\n.vault-info-section .preview-image {\n    object-fit: scale-down;\n    margin-top: 40px\n}\n\n.vault-stats-section-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    align-content: center;\n    margin-top: 60px;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-stats-section-container .vault-stats-item-container {\n    background: #14191d;\n    margin-inline:5px;display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    padding: 0px 10px;\n    border-radius: 11px;\n    min-width: 200px;\n    min-height: 150px;\n    margin-top: 10px;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-stats-section-container .vault-stats-item-container .value {\n    position: relative;\n    font-size: 1em;\n    font-size: 26px;\n    margin-bottom: 16px;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-stats-section-container .vault-stats-item-container .title {\n    position: relative;\n    font-size: 15px;\n    font-weight: 200;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-stats-section-container .vault-stats-item-container .box {\n    perspective: 120px;\n    margin-right: 15px;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-stats-section-container .vault-stats-item-container .box .coin {\n    width: .5em;\n    height: .5em;\n    border: 2px solid #fff;\n    animation: spin 1.5s ease-in-out infinite\n}\n\n@keyframes spin {\n    to {\n        transform: rotateY(540deg)\n    }\n}\n\n.vault-item-container {\n    background: #14191d;\n    margin-inline:5px;display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-content: center;\n    align-items: center;\n    padding: 10px;\n    border-radius: 11px;\n    min-width: 200px;\n    margin-top: 10px;\n    min-height: 200px;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-item-container .image-container {\n    position: relative;\n    display: flex\n}\n\n.vault-item-container .image-container .image {\n    width: 190px;\n    height: 190px;\n    border-radius: 8px;\n    object-fit: contain\n}\n\n.vault-item-container .image-container .image-text {\n    position: absolute;\n    bottom: 0px;\n    right: 0px;\n    background: #ff2222;\n    color: #000;\n    padding: 4px 10px;\n    font-size: 11px;\n    font-weight: 300;\n    border-radius: 0px 0px 8px 0px\n}\n\n.vault-item-container .busy-container {\n    background: rgba(0,0,0,.7490196078);\n    width: 190px;\n    height: 190px;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-radius: 8px;\n    display: flex\n}\n\n.vault-item-container .busy-container .busy-loader {\n    position: relative;\n    width: 30px;\n    height: 30px;\n    border: 3px solid #ff2222;\n    overflow: hidden;\n    animation: spin 5s ease infinite;\n    margin: auto\n}\n\n.vault-item-container .busy-container .busy-loader::before {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 30px;\n    height: 30px;\n    background-color: rgba(246,213,0,.5333333333);\n    transform-origin: center bottom;\n    transform: scaleY(1);\n    animation: fill 5s linear infinite\n}\n\n.vault-item-container .staked-container {\n    width: 100%;\n    text-align: center;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: space-between\n}\n\n.vault-item-container .staked-container .staked-info-container {\n    width: 100%;\n    display: flex;\n    font-size: 12px;\n    justify-content: center;\n    border-radius: 0px;\n    height: 100%;\n    flex-direction: column\n}\n\n.vault-item-container .staked-container .staked-info-container .staked-info-section {\n    padding-block:10px}\n\n.vault-item-container .staked-container .staked-info-container .multiplier-info-section {\n    margin-bottom: 10px;\n    color: #fedd03;\n    background: rgba(255,255,255,.1294117647);\n    padding-block:2px;font-size: 10px\n}\n\n.vault-item-container .staked-container .staked-info-container .divider {\n    width: 80%;\n    border-top: 1px solid rgba(255,255,255,.102);\n    margin: auto\n}\n\n.vault-item-container .staked-container .time-left {\n    display: none;\n    font-size: 15px;\n    font-weight: 100\n}\n\n.vault-item-container .staked-container .time-left .items-container {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center\n}\n\n.vault-item-container .staked-container .time-left .items-container .divider {\n    height: 24px;\n    width: 1px;\n    background: rgba(255,255,255,.1019607843);\n    margin-inline:2px}\n\n.vault-item-container .staked-container .time-left .items-container .item-container {\n    position: relative;\n    margin-inline:7px;display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center\n}\n\n.vault-item-container .staked-container .time-left .items-container .item-container .item-value {\n    position: relative;\n    font-weight: 200;\n    margin-right: 3px\n}\n\n.vault-item-container .staked-container .time-left .items-container .item-container .item-title {\n    position: relative;\n    font-size: 11px;\n    color: #ff2222;\n    font-weight: 200\n}\n\n.vault-item-container .staked-container progress {\n    border-radius: 70px;\n    width: 100%;\n    height: 10px;\n    box-shadow: 1px 1px 4px rgba(0,0,0,.2)\n}\n\n.vault-item-container .staked-container progress::-webkit-progress-bar {\n    background-color: #30383d;\n    border-radius: 70px\n}\n\n.vault-item-container .staked-container progress::-webkit-progress-value {\n    background-color: #06ffc3;\n    border-radius: 70px;\n    box-shadow: 0px 0px 5px 3px rgba(6,255,197,.4235294118)\n}\n\n@keyframes spin {\n    50%,100% {\n        transform: rotate(360deg)\n    }\n}\n\n@keyframes fill {\n    25%,50% {\n        transform: scaleY(0)\n    }\n\n    100% {\n        transform: scaleY(1)\n    }\n}\n\n.vault-items-section-container {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    justify-content: center;\n    flex-wrap: wrap;\n    align-content: center;\n    max-width: 1000px;\n    margin: auto;\n    margin-top: 20px;\n    animation: fadeIn 1s ease-in\n}\n\n.section-title {\n    margin: auto;\n    text-align: center;\n    margin-top: 80px;\n    font-size: 30px;\n    font-weight: 800;\n    background: ff2222;\n    color: #1c111b;\n    letter-spacing: 10px;\n    width: fit-content;\n    padding: 10px 80px;\n    animation: fadeIn 1s ease-in\n}\n\n.section-title-unstaked {\n    margin: auto;\n    text-align: center;\n    margin-top: 80px;\n    font-size: 30px;\n    font-weight: 200;\n    color: ff2222;\n    letter-spacing: 10px;\n    width: fit-content;\n    padding: 10px 80px;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-toolbar-container {\n    margin-inline:5px;display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-content: center;\n    padding: 7px 0px;\n    border-radius: 11px;\n    min-width: 180px;\n    margin-top: 20px;\n    animation: fadeIn 1s ease-in;\n    align-items: stretch;\n    flex-wrap: wrap\n}\n\n.vault-toolbar-container .action-container {\n    margin-inline:5px}\n\n.vault-toolbar-container .action-container * .action-container-stake::before {\n    font-size: 24px;\n    padding: 8px 20px;\n    letter-spacing: 5px;\n    font-weight: 350;\n    content: \"STAKE\"\n}\n\n.vault-toolbar-container .action-container * .action-container-unstake::before {\n    font-size: 24px;\n    padding: 8px 20px;\n    letter-spacing: 5px;\n    font-weight: 350;\n    content: \"UNSTAKE\";\n}\n\n.vault-toolbar-container .vertical-border {\n    position: relative;\n    height: 40px;\n    width: 2px;\n    margin-inline:26px;background: rgba(255,255,255,.4117647059);\n    border-radius: 10px\n}\n\n.vault-toolbar-container .auto-staking-container {\n    background: #2d2444;\n    margin-inline:5px;display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    padding: 10px 10px;\n    border-radius: 11px;\n    min-width: 200px;\n    flex-wrap: nowrap;\n    margin: 10px\n}\n\n.vault-toolbar-container .auto-staking-container .status-container {\n    margin-right: 23px\n}\n\n.vault-toolbar-container .auto-staking-container .status-container .title {\n    font-size: 9px\n}\n\n.vault-toolbar-container .auto-staking-container .status-container .status-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-toolbar-container .auto-staking-container .status-container .status-container .status-indicator-off {\n    width: 10px;\n    height: 10px;\n    border-radius: 20px;\n    background: red;\n    margin-right: 15px\n}\n\n.vault-toolbar-container .auto-staking-container .status-container .status-container .status-indicator-on {\n    width: 10px;\n    height: 10px;\n    border-radius: 20px;\n    background: #00a308;\n    margin-right: 15px\n}\n\n.vault-toolbar-container .auto-staking-container .status-container .status-container .status {\n    font-size: 21px;\n    font-weight: 100\n}\n\n.vault-toolbar-container .balls {\n    width: 4em;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: space-between;\n    margin: auto;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-toolbar-container .balls div {\n    width: .8em;\n    height: .8em;\n    border-radius: 50%;\n    background-color: #fff\n}\n\n.vault-toolbar-container .balls div:nth-of-type(1) {\n    transform: translateX(-100%);\n    animation: left-swing .5s ease-in alternate infinite\n}\n\n.vault-toolbar-container .balls div:nth-of-type(3) {\n    transform: translateX(-95%);\n    animation: right-swing .5s ease-out alternate infinite\n}\n\n@keyframes left-swing {\n    50%,100% {\n        transform: translateX(95%)\n    }\n}\n\n@keyframes right-swing {\n    50% {\n        transform: translateX(-95%)\n    }\n\n    100% {\n        transform: translateX(100%)\n    }\n}\n\n.vault-toolbar-container .box {\n    perspective: 120px;\n    margin-right: 15px;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-toolbar-container .box .coin {\n    width: .5em;\n    height: .5em;\n    border: 2px solid #fff;\n    animation: spin 1.5s ease-in-out infinite\n}\n\n@keyframes spin {\n    to {\n        transform: rotateY(540deg)\n    }\n}\n\n.toolbat-alert-container {\n    width: 340px;\n    margin: auto;\n    padding: 10px;\n    border-radius: 10px;\n    margin-top: 20px;\n    text-align: center\n}\n\n.small {\n    background: rgba(0,0,0,0);\n    border: 1px solid #fff;\n    box-sizing: border-box;\n    border-radius: 5px;\n    padding: 5px !important;\n    min-width: 87px !important;\n    color: #fff;\n    font-size: 11px !important;\n    font-weight: 300\n}\n\n.ab-base {\n    outline: none;\n    border: none;\n    font-family: \"Poppins\";\n    cursor: pointer;\n    transition: all .1s ease-in-out\n}\n\n.primary {\n    background: #00ff6a;\n    border-radius: 5px;\n    font-size: 15px;\n    padding: 12px;\n    min-width: 230px;\n    color: #000;\n    font-weight: 500\n}\n\n.primary:hover {\n    background: rgba(240,208,0,.9647058824)\n}\n\n.primary:active {\n    background: rgba(211,183,1,.9647058824)\n}\n\n.light {\n    background: rgba(0,0,0,0);\n    border: 1px solid #fff;\n    box-sizing: border-box;\n    border-radius: 5px;\n    padding: 12px;\n    min-width: 230px;\n    color: #fff;\n    font-size: 15px;\n    font-weight: 300\n}\n\n.light:hover {\n    background: rgba(240,208,0,.0823529412)\n}\n\n.light:active {\n    background: rgba(255,255,255,.2117647059)\n}\n\n.close-overlay-btn {\n    background: rgba(255,255,255,.0901960784);\n    border-radius: 100px;\n    position: fixed;\n    z-index: 100;\n    top: 20px;\n    right: 220px;\n    transition: all .2s\n}\n\n.close-overlay-btn:hover {\n    background: rgba(255,255,255,.1568627451)\n}\n\n.close-overlay-btn:active {\n    background: rgba(255,255,255,.2666666667)\n}\n\n.vault-stake-container {\n    position: relative;\n    display: flex;\n    position: relative;\n    width: 100vw;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 100px;\n    color: #fff;\n    animation: fadeIn .4s ease-in\n}\n\n.vault-stake-container .title {\n    position: relative;\n    font-size: 2em\n}\n\n.vault-stake-container .explainer {\n    position: relative\n}\n\n.vault-stake-container .no-items {\n    margin-top: 60px;\n    background: rgba(175,12,0,.2);\n    padding: 10px\n}\n\n.vault-stake-container .form-container {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: row;\n    width: 80vw;\n    margin: 0px auto;\n    margin-top: 30px\n}\n\n.vault-stake-container .form-container .form-item-container {\n    display: grid;\n    justify-items: center;\n    margin-top: 20px\n}\n\n.vault-stake-container .form-container .form-item-container .form-title {\n    font-size: 13px\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;display: flex;\n    cursor: pointer;\n    transition: all 100ms;\n    align-items: flex-start\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item {\n    position: relative;\n    width: 70px;\n    height: 70px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms;\n    opacity: .8\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {\n    width: 100%;\n    height: 100%;\n    background: rgba(240,208,0,.7294117647);\n    display: flex\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {\n    width: 40px;\n    margin: auto;\n    object-fit: contain;\n    height: 40px\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item-selected {\n    opacity: .8\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item {\n    opacity: 1\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n\n    100% {\n        opacity: 1\n    }\n}\n\n.select-plan-main-container {\n    display: flex;\n    max-width: 100vw;\n    overflow: auto;\n    margin-top: 40px;\n    scrollbar-width: none;\n    flex-wrap: wrap;\n    justify-content: space-around\n}\n\n.select-plan-main-container::-webkit-scrollbar {\n    display: none\n}\n\n.select-plan-main-container .plan-container {\n    background: rgba(64,64,64,.1294117647);\n    padding: 25px;\n    border: 1px solid #ffeb3b;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    max-width: 380px;\n    min-width: 290px;\n    overflow: hidden;\n    margin-inline:20px}\n\n.select-plan-main-container .line-break {\n    white-space: pre-line;\n    width: revert;\n    word-wrap: break-word\n}\n\n.minting-button-main-container {\n    padding: 50px 20px;\n    border: 1px solid rgba(255,255,255,.2392156863);\n    border-radius: 10px;\n    min-width: 200px;\n    margin-top: 40px;\n    background: rgba(30,30,30,.5411764706);\n    width: 350px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    align-content: center;\n    animation: fadeIn .2s ease-in\n}\n\n.minting-button-main-container .message {\n    font-weight: 200;\n    font-size: 24px\n}\n\n.minting-button-main-container .may-take {\n    font-size: 12px;\n    margin-top: 10px;\n    font-weight: 600;\n    color: rgba(255,255,255,.4784313725)\n}\n\n.wallet-btn {\n    background: rgba(0,0,0,0) !important;\n    border: 1px solid #ff2222 !important;\n    font-family: \"Poppins\" !important;\n    font-weight: 200 !important;\n    font-size: 12px !important;\n    padding: 0px 40px !important;\n    margin: auto\n}\n\n.minting-button-loader {\n    position: relative;\n    width: 30px;\n    height: 30px;\n    border: 3px solid #ff2222;\n    overflow: hidden;\n    animation: spin 5s ease infinite;\n    margin: auto;\n    margin-bottom: 20px\n}\n\n.minting-button-loader::before {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 30px;\n    height: 30px;\n    background-color: rgba(246,213,0,.5333333333);\n    transform-origin: center bottom;\n    transform: scaleY(1);\n    animation: fill 5s linear infinite\n}\n\n@keyframes spin {\n    50%,100% {\n        transform: rotate(360deg)\n    }\n}\n\n@keyframes fill {\n    25%,50% {\n        transform: scaleY(0)\n    }\n\n    100% {\n        transform: scaleY(1)\n    }\n}\n\n.select-plan-main-container .plan-container {\n    background: rgba(64,64,64,.1294117647);\n    padding: 25px;\n    border: 1px solid #ffeb3b;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    max-width: 380px;\n    min-width: 290px;\n    overflow: hidden\n}\n\n.select-plan-main-container .line-break {\n    white-space: pre-line;\n    width: revert;\n    word-wrap: break-word\n}\n\n*>.reward-token-name {\n    display: inherit\n}\n\n.close-overlay-btn {\n    background: rgba(255,255,255,.0901960784);\n    border-radius: 100px;\n    position: fixed;\n    z-index: 100;\n    top: 20px;\n    right: 220px;\n    transition: all .2s\n}\n\n.close-overlay-btn:hover {\n    background: rgba(255,255,255,.1568627451)\n}\n\n.close-overlay-btn:active {\n    background: rgba(255,255,255,.2666666667)\n}\n\n.vault-stake-container {\n    position: relative;\n    display: flex;\n    position: relative;\n    width: 100vw;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 100px;\n    color: #fff;\n    animation: fadeIn .4s ease-in\n}\n\n.vault-stake-container .title {\n    position: relative;\n    font-size: 2em\n}\n\n.vault-stake-container .explainer {\n    position: relative\n}\n\n.vault-stake-container .no-items {\n    margin-top: 60px;\n    background: rgba(175,12,0,.2);\n    padding: 10px\n}\n\n.vault-stake-container .form-container {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: row;\n    width: 80vw;\n    margin: 0px auto;\n    margin-top: 30px\n}\n\n.vault-stake-container .form-container .form-item-container {\n    display: grid;\n    justify-items: center;\n    margin-top: 20px\n}\n\n.vault-stake-container .form-container .form-item-container .form-title {\n    font-size: 13px\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;display: flex;\n    cursor: pointer;\n    transition: all 100ms;\n    align-items: flex-start\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item {\n    position: relative;\n    width: 70px;\n    height: 70px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms;\n    opacity: .8\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {\n    width: 100%;\n    height: 100%;\n    background: rgba(240,208,0,.7294117647);\n    display: flex\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {\n    width: 40px;\n    margin: auto;\n    object-fit: contain;\n    height: 40px\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item-selected {\n    opacity: .8\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item {\n    opacity: 1\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n\n    100% {\n        opacity: 1\n    }\n}\n\n.select-plan-main-container .plan-container {\n    background: rgba(64,64,64,.1294117647);\n    padding: 25px;\n    border: 1px solid #ffeb3b;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    max-width: 380px;\n    min-width: 290px;\n    overflow: hidden\n}\n\n.select-plan-main-container .line-break {\n    white-space: pre-line;\n    width: revert;\n    word-wrap: break-word\n}\n\n.minting-button-main-container {\n    padding: 50px 20px;\n    border: 1px solid rgba(255,255,255,.2392156863);\n    border-radius: 10px;\n    min-width: 200px;\n    margin-top: 40px;\n    background: rgba(30,30,30,.5411764706);\n    width: 350px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    align-content: center;\n    animation: fadeIn .2s ease-in\n}\n\n.minting-button-main-container .message {\n    font-weight: 200;\n    font-size: 24px\n}\n\n.minting-button-main-container .may-take {\n    font-size: 12px;\n    margin-top: 10px;\n    font-weight: 600;\n    color: rgba(255,255,255,.4784313725)\n}\n\n.wallet-btn {\n    background: rgba(0,0,0,0) !important;\n    border: 1px solid #ff2222 !important;\n    font-family: \"Poppins\" !important;\n    font-weight: 200 !important;\n    font-size: 12px !important;\n    padding: 0px 40px !important;\n    margin: auto\n}\n\n.minting-button-loader {\n    position: relative;\n    width: 30px;\n    height: 30px;\n    border: 3px solid #ff2222;\n    overflow: hidden;\n    animation: spin 5s ease infinite;\n    margin: auto;\n    margin-bottom: 20px\n}\n\n.minting-button-loader::before {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 30px;\n    height: 30px;\n    background-color: rgba(246,213,0,.5333333333);\n    transform-origin: center bottom;\n    transform: scaleY(1);\n    animation: fill 5s linear infinite\n}\n\n@keyframes spin {\n    50%,100% {\n        transform: rotate(360deg)\n    }\n}\n\n@keyframes fill {\n    25%,50% {\n        transform: scaleY(0)\n    }\n\n    100% {\n        transform: scaleY(1)\n    }\n}\n\n.vault-balance-main-container {\n    position: relative;\n    display: flex;\n    margin: auto;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: 20px;\n}\n\n.vault-balance-main-container .vault-balance-container {\n    background: #1d1827;\n    margin-inline:5px;display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-content: center;\n    align-items: center;\n    padding: 20px 20px;\n    border-radius: 11px;\n    min-width: 220px;\n    margin-top: 10px;\n    animation: fadeIn 1s ease-in\n}\n\n.vault-balance-main-container .vault-balance-container .vault-balance-split-container .token-withdraw-container {\n    display: flex;\n    justify-content: space-between;\n}\n\n.vault-balance-main-container .vault-balance-container .vault-balance-split-container .token-withdraw-container .token-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start\n}\n\n.vault-balance-main-container .vault-balance-container .vault-balance-split-container .token-withdraw-container .token-container .token-title {\n    font-weight: 300;\n    font-size: 11px\n}\n\n.vault-balance-main-container .vault-balance-container .vault-balance-split-container .token-withdraw-container .token-container .token-value {\n    font-weight: 600;\n    color: #00ff6a;\n    font-size: 21px\n}\n\n.vault-balance-main-container .vault-balance-container .vault-balance-split-container .reward-pool-alert-container {\n    background: rgba(255,0,0,.368627451);\n    padding: 20px;\n    width: 300px;\n    font-size: 11px;\n    margin-top: 10px;\n    border-radius: 10px\n}\n\n.vault-balance-main-container .vault-balance-container .vault-balance-split-container .reward-pool-alert-container .title {\n    font-weight: 700\n}\n\n.vault-balance-main-container .vault-balance-container .vault-balance-split-container .reward-pool-alert-container .description {\n    margin: 0px\n}\n\n.close-overlay-btn {\n    background: rgba(255,255,255,.0901960784);\n    border-radius: 100px;\n    position: fixed;\n    z-index: 100;\n    top: 20px;\n    right: 220px;\n    transition: all .2s\n}\n\n.close-overlay-btn:hover {\n    background: rgba(255,255,255,.1568627451)\n}\n\n.close-overlay-btn:active {\n    background: rgba(255,255,255,.2666666667)\n}\n\n.multiplier-stake-container {\n    position: relative;\n    display: flex;\n    position: relative;\n    width: 100vw;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 100px;\n    color: #fff;\n    animation: fadeIn .4s ease-in\n}\n\n.multiplier-stake-container .title {\n    position: relative;\n    font-size: 2em\n}\n\n.multiplier-stake-container .explainer {\n    position: relative;\n    max-width: 95vw;\n    text-align: center\n}\n\n.multiplier-stake-container .no-items {\n    margin-top: 60px;\n    background: rgba(175,12,0,.2);\n    padding: 10px\n}\n\n.multiplier-stake-container .form-container {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: row;\n    width: 80vw;\n    margin: 0px auto;\n    margin-top: 30px\n}\n\n.multiplier-stake-container .form-container .form-item-container {\n    display: grid;\n    justify-items: center;\n    margin-top: 20px\n}\n\n.multiplier-stake-container .form-container .form-item-container .form-title {\n    font-size: 13px\n}\n\n.multiplier-stake-container .form-container .form-item-container .form-item-inner-container {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;display: flex;\n    cursor: pointer;\n    transition: all 100ms;\n    align-items: flex-start\n}\n\n.multiplier-stake-container .form-container .form-item-container .form-item-inner-container .form-item {\n    position: relative;\n    width: 70px;\n    height: 70px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms;\n    opacity: .8\n}\n\n.multiplier-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms\n}\n\n.multiplier-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {\n    width: 100%;\n    height: 100%;\n    background: rgba(240,208,0,.7294117647);\n    display: flex\n}\n\n.multiplier-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {\n    width: 40px;\n    margin: auto;\n    object-fit: contain;\n    height: 40px\n}\n\n.multiplier-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item-selected {\n    opacity: .8\n}\n\n.multiplier-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item {\n    opacity: 1\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n\n    100% {\n        opacity: 1\n    }\n}\n\n.select-plan-main-container {\n    display: flex;\n    max-width: 100vw;\n    overflow: auto;\n    margin-top: 40px;\n    -ms-overflow-style: none;\n    scrollbar-width: none\n}\n\n.select-plan-main-container::-webkit-scrollbar {\n    display: none\n}\n\n.select-plan-main-container .plan-container {\n    background: rgba(64,64,64,.1294117647);\n    padding: 25px;\n    border: 1px solid #ffeb3b;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    max-width: 380px;\n    min-width: 290px;\n    overflow: hidden;\n    margin-inline:20px}\n\n.select-plan-main-container .line-break {\n    white-space: pre-line;\n    width: revert;\n    word-wrap: break-word\n}\n\n.select-multiplier-plan-main-container {\n    display: flex;\n    overflow: auto;\n    max-width: 100vw;\n    flex-wrap: wrap;\n    justify-content: center\n}\n\n.select-multiplier-plan-main-container .plan-container {\n    background: rgba(64,64,64,.1294117647);\n    padding: 25px;\n    border: 1px solid #ffeb3b;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    max-width: 380px;\n    margin-top: 40px;\n    min-width: 290px;\n    overflow: hidden;\n    margin-inline:20px}\n\n.select-multiplier-plan-main-container .line-break {\n    white-space: pre-line;\n    width: revert;\n    word-wrap: break-word\n}\n\n.minting-button-main-container {\n    padding: 50px 20px;\n    border: 1px solid rgba(255,255,255,.2392156863);\n    border-radius: 10px;\n    min-width: 200px;\n    margin-top: 40px;\n    background: rgba(30,30,30,.5411764706);\n    width: 350px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    align-content: center;\n    animation: fadeIn .2s ease-in\n}\n\n.minting-button-main-container .message {\n    font-weight: 200;\n    font-size: 24px\n}\n\n.minting-button-main-container .may-take {\n    font-size: 12px;\n    margin-top: 10px;\n    font-weight: 600;\n    color: rgba(255,255,255,.4784313725)\n}\n\n.wallet-btn {\n    background: rgba(0,0,0,0) !important;\n    border: 1px solid #ff2222 !important;\n    font-family: \"Poppins\" !important;\n    font-weight: 200 !important;\n    font-size: 12px !important;\n    padding: 0px 40px !important;\n    margin: auto\n}\n\n.minting-button-loader {\n    position: relative;\n    width: 30px;\n    height: 30px;\n    border: 3px solid #ff2222;\n    overflow: hidden;\n    animation: spin 5s ease infinite;\n    margin: auto;\n    margin-bottom: 20px\n}\n\n.minting-button-loader::before {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 30px;\n    height: 30px;\n    background-color: rgba(246,213,0,.5333333333);\n    transform-origin: center bottom;\n    transform: scaleY(1);\n    animation: fill 5s linear infinite\n}\n\n@keyframes spin {\n    50%,100% {\n        transform: rotate(360deg)\n    }\n}\n\n@keyframes fill {\n    25%,50% {\n        transform: scaleY(0)\n    }\n\n    100% {\n        transform: scaleY(1)\n    }\n}\n\n.multiplier-main-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: rgba(0,0,0,.3294117647);\n    padding-block:20px;margin-block:20px}\n\n.multiplier-main-container .multiplier-title {\n    margin: auto;\n    text-align: center;\n    margin-top: 0px;\n    font-size: 17px;\n    font-weight: 900;\n    color: ff2222;\n    letter-spacing: 4px;\n    width: -moz-fit-content;\n    width: fit-content;\n    padding: 10px 80px;\n    animation: fadeIn 1s ease-in\n}\n\n.multiplier-main-container .multiplier-actions-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    flex-direction: row;\n    justify-content: center;\n    align-items: stretch\n}\n\n.multiplier-main-container .multiplier-items-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center\n}\n\n.vault-multiplier-item-container {\n    background: #312745;\n    margin-inline:5px;display: flex;\n    flex-direction: column;\n    align-content: center;\n    align-items: center;\n    padding: 10px;\n    border-radius: 11px;\n    margin-top: 10px;\n    cursor: pointer;\n    animation: fadeIn 1s ease-in;\n    transition: all .3s;\n    justify-content: space-between\n}\n\n.vault-multiplier-item-container:hover {\n    background: #212a30\n}\n\n.vault-multiplier-item-container:active {\n    background: #181d23\n}\n\n.vault-multiplier-item-container .image-container {\n    position: relative;\n    display: flex\n}\n\n.vault-multiplier-item-container .image-container .image {\n    width: 90px;\n    height: 90px;\n    border-radius: 7px;\n    object-fit: contain\n}\n\n.vault-multiplier-item-container .image-container .image-text {\n    position: absolute;\n    bottom: 0px;\n    right: 0px;\n    background: #ff2222;\n    color: #000;\n    padding: 4px 10px;\n    font-size: 11px;\n    font-weight: 300;\n    border-radius: 0px 0px 8px 0px\n}\n\n.vault-multiplier-item-container .busy-container {\n    background: rgba(0,0,0,.7490196078);\n    width: 190px;\n    height: 190px;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-radius: 8px;\n    display: flex\n}\n\n.vault-multiplier-item-container .busy-container .busy-loader {\n    position: relative;\n    width: 30px;\n    height: 30px;\n    border: 3px solid #ff2222;\n    overflow: hidden;\n    animation: spin 5s ease infinite;\n    margin: auto\n}\n\n.vault-multiplier-item-container .busy-container .busy-loader::before {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 30px;\n    height: 30px;\n    background-color: rgba(246,213,0,.5333333333);\n    transform-origin: center bottom;\n    transform: scaleY(1);\n    animation: fill 5s linear infinite\n}\n\n.vault-multiplier-item-container .staked-container {\n    width: 100%;\n    text-align: center\n}\n\n.vault-multiplier-item-container .staked-container .busy-unstaking {\n    font-size: 10px;\n    margin-top: 8px\n}\n\n.vault-multiplier-item-container .staked-container .staked-info-container {\n    width: 100%;\n    display: flex;\n    font-size: 12px;\n    justify-content: space-around;\n    border-radius: 0px;\n    flex-direction: column\n}\n\n.vault-multiplier-item-container .staked-container .staked-info-container .staked-info-section {\n    padding-block:4px}\n\n.vault-multiplier-item-container .staked-container .staked-info-container .staked-info-section .in-use {\n    font-size: 7px\n}\n\n.vault-multiplier-item-container .staked-container .staked-info-container .staked-info-section .UNLIMITED {\n    color: ff2222;\n    font-size: 13px\n}\n\n.vault-multiplier-item-container .staked-container .staked-info-container .staked-program-info-section {\n    padding-block:4px;font-size: 10px\n}\n\n.vault-multiplier-item-container .staked-container .staked-info-container .divider {\n    width: 80%;\n    border-top: 1px solid rgba(255,255,255,.102);\n    margin: auto\n}\n\n.vault-multiplier-item-container .staked-container .activate {\n    font-size: 10px;\n    margin-top: 10px;\n    color: #ff2222\n}\n\n.vault-multiplier-item-container .staked-container .time-left {\n    font-size: 15px;\n    font-weight: 100\n}\n\n.vault-multiplier-item-container .staked-container .time-left .items-container {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center\n}\n\n.vault-multiplier-item-container .staked-container .time-left .items-container .divider {\n    height: 24px;\n    width: 1px;\n    background: rgba(255,255,255,.1019607843);\n    margin-inline:2px}\n\n.vault-multiplier-item-container .staked-container .time-left .items-container .item-container {\n    position: relative;\n    margin-inline:7px;display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center\n}\n\n.vault-multiplier-item-container .staked-container .time-left .items-container .item-container .item-value {\n    position: relative;\n    font-weight: 200;\n    margin-right: 3px\n}\n\n.vault-multiplier-item-container .staked-container .time-left .items-container .item-container .item-title {\n    position: relative;\n    font-size: 11px;\n    color: #ff2222;\n    font-weight: 200\n}\n\n.vault-multiplier-item-container .staked-container progress {\n    border-radius: 70px;\n    width: 100%;\n    height: 10px;\n    box-shadow: 1px 1px 4px rgba(0,0,0,.2)\n}\n\n.vault-multiplier-item-container .staked-container progress::-webkit-progress-bar {\n    background-color: #30383d;\n    border-radius: 70px\n}\n\n.vault-multiplier-item-container .staked-container progress::-webkit-progress-value {\n    background-color: #06ffc3;\n    border-radius: 70px;\n    box-shadow: 0px 0px 5px 3px rgba(6,255,197,.4235294118)\n}\n\n@keyframes spin {\n    50%,100% {\n        transform: rotate(360deg)\n    }\n}\n\n@keyframes fill {\n    25%,50% {\n        transform: scaleY(0)\n    }\n\n    100% {\n        transform: scaleY(1)\n    }\n}\n\n.close-overlay-btn {\n    background: rgba(255,255,255,.0901960784);\n    border-radius: 100px;\n    position: fixed;\n    z-index: 100;\n    top: 20px;\n    right: 220px;\n    transition: all .2s\n}\n\n.close-overlay-btn:hover {\n    background: rgba(255,255,255,.1568627451)\n}\n\n.close-overlay-btn:active {\n    background: rgba(255,255,255,.2666666667)\n}\n\n.multiplier-info-main-container {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 10px;\n    align-items: center\n}\n\n.multiplier-info-main-container .multiplier-image {\n    width: 100px;\n    height: 100px;\n    object-fit: contain;\n    border-radius: 10px\n}\n\n.multiplier-info-main-container .multiplier-info-container .multiplier-name {\n    color: #ff2222;\n    font-weight: 500\n}\n\n.multiplier-info-main-container .multiplier-info-container .multiplier-bonus-desc {\n    font-size: 14px;\n    width: 200px;\n    margin-top: 10px;\n    font-weight: 200\n}\n\n.fade-in-ani {\n    animation: fadeIn .2s ease-in\n}\n\n.multipler-activate-container {\n    position: relative;\n    display: flex;\n    position: relative;\n    width: 100vw;\n    flex-direction: column;\n    align-items: center;\n    margin-block:100px;color: #fff;\n    animation: fadeIn .4s ease-in\n}\n\n.multipler-activate-container .multiplier-helper {\n    background: rgba(255,255,255,.0588235294);\n    padding: 12px;\n    width: 320px;\n    margin-block:30px;text-align: center;\n    font-weight: 100\n}\n\n.multipler-activate-container .title {\n    position: relative;\n    font-size: 2em\n}\n\n.multipler-activate-container .explainer {\n    position: relative\n}\n\n.multipler-activate-container .acitions {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    margin-block:10px;justify-content: center\n}\n\n.multipler-activate-container .no-items {\n    margin-top: 60px;\n    background: rgba(175,12,0,.2);\n    padding: 10px\n}\n\n.multipler-activate-container .multiplier-form-container {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: row;\n    width: 80vw;\n    margin: 0px auto;\n    margin-top: 30px\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container {\n    display: grid;\n    justify-items: center;\n    margin-top: 20px\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-title {\n    font-size: 13px\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-calculated-bonus {\n    color: #ff2222;\n    font-size: 13px\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;display: flex;\n    cursor: pointer;\n    transition: all 100ms;\n    align-items: flex-start\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item {\n    position: relative;\n    width: 70px;\n    height: 70px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms;\n    opacity: .8\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item .selected-container {\n    width: 100%;\n    height: 100%;\n    background: rgba(240,208,0,.7294117647);\n    display: flex\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item .selected-container .tick {\n    width: 30px;\n    margin: auto;\n    object-fit: contain;\n    height: 30px\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item-selected {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {\n    width: 100%;\n    height: 100%;\n    background: rgba(240,208,0,.7294117647);\n    display: flex\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {\n    width: 40px;\n    margin: auto;\n    object-fit: contain;\n    height: 40px\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container:hover .form-item-selected {\n    opacity: .8\n}\n\n.multipler-activate-container .multiplier-form-container .form-item-container .form-item-inner-container:hover .form-item {\n    opacity: 1\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n\n    100% {\n        opacity: 1\n    }\n\n    0% {\n        opacity: 0\n    }\n}\n\n.select-plan-main-container {\n    display: flex;\n    max-width: 100vw;\n    overflow: auto;\n    margin-top: 40px;\n    -ms-overflow-style: none;\n    scrollbar-width: none\n}\n\n.select-plan-main-container::-webkit-scrollbar {\n    display: none\n}\n\n.select-plan-main-container .plan-container {\n    background: rgba(64,64,64,.1294117647);\n    padding: 25px;\n    border: 1px solid #ffeb3b;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    max-width: 380px;\n    min-width: 290px;\n    overflow: hidden;\n    margin-inline:20px}\n\n.select-plan-main-container .line-break {\n    white-space: pre-line;\n    width: revert;\n    word-wrap: break-word\n}\n\n.close-overlay-btn {\n    background: rgba(255,255,255,.0901960784);\n    border-radius: 100px;\n    position: fixed;\n    z-index: 100;\n    top: 20px;\n    right: 220px;\n    transition: all .2s\n}\n\n.close-overlay-btn:hover {\n    background: rgba(255,255,255,.1568627451)\n}\n\n.close-overlay-btn:active {\n    background: rgba(255,255,255,.2666666667)\n}\n\n.vault-stake-container {\n    position: relative;\n    display: flex;\n    position: relative;\n    width: 100vw;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 100px;\n    color: #fff;\n    animation: fadeIn .4s ease-in\n}\n\n.vault-stake-container .title {\n    position: relative;\n    font-size: 2em\n}\n\n.vault-stake-container .explainer {\n    position: relative\n}\n\n.vault-stake-container .no-items {\n    margin-top: 60px;\n    background: rgba(175,12,0,.2);\n    padding: 10px\n}\n\n.vault-stake-container .form-container {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: row;\n    width: 80vw;\n    margin: 0px auto;\n    margin-top: 30px\n}\n\n.vault-stake-container .form-container .form-item-container {\n    display: grid;\n    justify-items: center;\n    margin-top: 20px\n}\n\n.vault-stake-container .form-container .form-item-container .form-title {\n    font-size: 13px\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;display: flex;\n    cursor: pointer;\n    transition: all 100ms;\n    align-items: flex-start\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item {\n    position: relative;\n    width: 70px;\n    height: 70px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms;\n    opacity: .8\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-inline:10px;margin: 0px auto;\n    cursor: pointer;\n    transition: all 100ms\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container {\n    width: 100%;\n    height: 100%;\n    background: rgba(240,208,0,.7294117647);\n    display: flex\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container .form-item-selected .selected-container .tick {\n    width: 40px;\n    margin: auto;\n    object-fit: contain;\n    height: 40px\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item-selected {\n    opacity: .8\n}\n\n.vault-stake-container .form-container .form-item-container .form-item-inner-container:hover .form-item {\n    opacity: 1\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n\n    100% {\n        opacity: 1\n    }\n}\n\n.select-plan-main-container .plan-container {\n    background: rgba(64,64,64,.1294117647);\n    padding: 25px;\n    border: 1px solid #ffeb3b;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    max-width: 380px;\n    min-width: 290px;\n    overflow: hidden\n}\n\n.select-plan-main-container .line-break {\n    white-space: pre-line;\n    width: revert;\n    word-wrap: break-word\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
